import type { Thread } from './api';

/** Whether an outbound message in this thread is effectively signed with the agent's name. */
export function isEffectivelySigned(thread: Pick<Thread, 'sender_identity'>, workspaceDefault: boolean | null): boolean {
  const si = thread.sender_identity ?? 'default';
  if (si === 'on') return true;
  if (si === 'off') return false;
  return workspaceDefault ?? false;
}
